import { API_URLS } from 'app-constants/api';
import { CreateGroup, UpdateGroup } from 'store/admin/usergroups/types';
import { ApiRequest } from 'types';

import httpService from 'services/http.service';

export const createGroup =
  (group: CreateGroup): ApiRequest =>
  () =>
    httpService.post(API_URLS.usersgroups(), group);

export const getGroups: ApiRequest = () => httpService.get(API_URLS.usersgroups(), {});

export const updateGroup =
  (group: UpdateGroup): ApiRequest =>
  () => {
    const { id, ...copyUpdatedGroup } = group;
    return httpService.put(API_URLS.usersgroups(), { groupId: id, ...copyUpdatedGroup });
  };
